// extracted by mini-css-extract-plugin
export default {"container":"adminLayout_container__IfYnT","center":"adminLayout_center__-j8m7"};